import { Component } from '@angular/core';
import { IconComponent } from '../../controls/icons/icon/icon.component';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [IconComponent],
})
export class PageNotFoundComponent {}
